module.exports = __webpack_public_path__ + "static/img/icon_empty.a8aad8d2.png";